import React, { useEffect, useState } from 'react';
import { useDocumentLink, useBrokerLinks } from '@qover/hooks';
import { Container, Details, Summary } from './bikeAccordionFaq.styles';
import {
  pushQuoteSectionsGuarantee,
  pushQuoteSectionsExclusions,
  pushQuoteSectionsEligibility,
  pushQuoteSectionsClaim,
  pushQuoteSectionsInsurance,
  pushQuoteSectionsCancel,
  pushQuoteSectionsInsured,
  pushQuoteSectionsContact,
} from '../domain/customDataLayer';
import { useLocation, useHistory } from 'react-router-dom';

type Element = {
  title: any;
  description: any;
};

type BikeAccordionFaqProps = {
  openFirstElement?: boolean;
  translations: {
    cardInfo1: Element;
    cardInfo2: Element;
    cardInfo3: Element;
    cardInfo4: Element;
    cardInfo5: Element;
    cardInfo6: Element;
    cardInfo7: Element;
    cardInfo8: Element;
  };
};

function BikeAccordionFaq(props: BikeAccordionFaqProps) {
  const [mounted, setMounted] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const getLink = useDocumentLink();
  const brokerLinks = useBrokerLinks();
  const { translations } = props;

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <Container id="insurance-details">
      <Details
        onToggle={(e: any) => {
          if (!e.target.open) {
            history.push({ ...location, hash: undefined });
          }
          pushQuoteSectionsGuarantee(e);
        }}
        open={mounted && location.hash === '#insurance-details'}
      >
        <Summary data-test="bike.accordion.card.info1.title">
          <span>{translations.cardInfo1.title}</span>
        </Summary>
        {translations.cardInfo1.description}
      </Details>
      <Details onToggle={pushQuoteSectionsExclusions}>
        <Summary data-test="bike.accordion.card.info2.title">
          <span>{translations.cardInfo2.title}</span>
        </Summary>
        {translations.cardInfo2.description}
      </Details>
      <Details onToggle={pushQuoteSectionsEligibility}>
        <Summary data-test="bike.accordion.card.info3.title">
          <span>{translations.cardInfo3.title}</span>
        </Summary>
        {translations.cardInfo3.description}
      </Details>
      <Details onToggle={pushQuoteSectionsClaim}>
        <Summary data-test="bike.accordion.card.info4.title">
          <span>{translations.cardInfo4.title}</span>
        </Summary>
        {translations.cardInfo4.description}
      </Details>
      <Details onToggle={pushQuoteSectionsInsurance}>
        <Summary data-test="bike.accordion.card.info5.title">
          <span>{translations.cardInfo5.title}</span>
        </Summary>
        {translations.cardInfo5.description({
          generalConditions: getLink('generalConditions'),
          IPID: getLink('IPID'),
          privacyPolicy: brokerLinks.privacyPolicy,
          fullFaq: brokerLinks.fullFaq,
        })}
      </Details>
      <Details onToggle={pushQuoteSectionsInsured}>
        <Summary data-test="bike.accordion.card.info6.title">
          <span>{translations.cardInfo6.title}</span>
        </Summary>
        {translations.cardInfo6.description}
      </Details>
      <Details onToggle={pushQuoteSectionsCancel}>
        <Summary data-test="bike.accordion.card.info7.title">
          <span>{translations.cardInfo7.title}</span>
        </Summary>
        {translations.cardInfo7.description}
      </Details>
      <Details onToggle={pushQuoteSectionsContact}>
        <Summary data-test="bike.accordion.card.info8.title">
          <span>{translations.cardInfo8.title}</span>
        </Summary>
        {translations.cardInfo8.description}
      </Details>
    </Container>
  );
}

export default BikeAccordionFaq;
